module.exports = __webpack_public_path__ + "img/file.8672d551.svg";